import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CallbackService } from '@library/utils/services/callback.service';
import { UserAgentService } from '@library/utils/services/user-agent.service';

@Injectable()
export class BlockBackButtonGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly userAgent: UserAgentService,
    private readonly callback: CallbackService,
  ) {}

  canActivate(): boolean {
    const previousUrl = this.router.getCurrentNavigation().previousNavigation?.finalUrl?.toString();
    if (typeof previousUrl !== 'undefined' && previousUrl.startsWith('/automations/')) {
      if (this.userAgent.isNativeApp()) {
        this.callback.call(this.callback.list.shouldExit);
      }
      else {
        window.history.go(-3);
      }
      return false;
    }
    return true;
  }
}
